/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUnitsQuery } from '../../models/get-units-query';
import { GetUnitsQueryResult } from '../../models/get-units-query-result';

export interface ApiNurseryManagerOrderStakeholderGetUnitsPost$Params {
      body?: GetUnitsQuery
}

export function apiNurseryManagerOrderStakeholderGetUnitsPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderGetUnitsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnitsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderGetUnitsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUnitsQueryResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderGetUnitsPost.PATH = '/api/NurseryManager/OrderStakeholder/GetUnits';
